var React = require('react');

function IconThemX (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-them-x"),React.createElement("g",{"id":"L","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"L-1366-PDP-EFK---Us-vs-Them","transform":"translate(-1012.000000, -2181.000000)","stroke":"#142B6F","strokeWidth":"3"},React.createElement("g",{"id":"US-V-THEM","transform":"translate(298.000000, 1898.000000)"},React.createElement("g",{"id":"Table","transform":"translate(0.000000, 254.000000)"},React.createElement("g",{"id":"icon-them","transform":"translate(714.000000, 29.000000)"},React.createElement("path",{"d":"M21,20 L5,4 L21,20 Z M21,4 L5,20 L21,4 Z","id":"Path"}))))))]);
}

IconThemX.defaultProps = {"width":"26px","height":"24px","viewBox":"0 0 26 24","version":"1.1"};

module.exports = IconThemX;

IconThemX.default = IconThemX;
